import React from "react";
import PropTypes from "prop-types";

import ChargingPinPublic from "./../../../client_customizations/assets/images/icons/charger-pin-public.svg";
import ChargingPinHighPower from "./../../../client_customizations/assets/images/icons/charger-pin-high-power.svg";
import ChargingPinDefault from "./../../../client_customizations/assets/images/icons/charger-pin-private.svg";
import ChargingPinDMultiple from "./../../../client_customizations/assets/images/icons/charger-pin-multiple.svg";
import isSuperChargingStation from "../../../utils/predicates/isSuperChargingStation";
import { FormattedMessage } from "react-intl";

import "./ChargingStationsMapLegend.scss";

const ChargingStationsMapLegend = ({ chargingStations }) => {
  const hasSuperChargerStations = (chargingStations || []).some((station) =>
    isSuperChargingStation(station)
  );

  return (
    <div className="legend ChargingStationsMapLegend">
      {hasSuperChargerStations && (
        <div className="charger-type">
          <img src={ChargingPinHighPower} alt="" />
          <b>
            <FormattedMessage
              id="chargingMap.highPowerStations"
              defaultMessage="High power stations"
              description="High-Power Stations Text"
            />
          </b>
          <br />
          <span>
            <FormattedMessage
              id="chargingMap.DCChargers"
              defaultMessage="DC fast chargers"
              description="DC fast charge or superchargers Text"
            />
          </span>
        </div>
      )}
      <div className="charger-type">
        <img src={ChargingPinPublic} alt="" />
        <b>
          <FormattedMessage
            id="chargingMap.public"
            defaultMessage="Public stations"
            description="Public Stations"
          />
        </b>
        <br />
        <span>
          <FormattedMessage
            id="chargingMap.businessGovernment"
            defaultMessage="Level 2 chargers"
            description="Level 2 chargers"
          />
        </span>
      </div>
      <div className="charger-type">
        <img src={ChargingPinDefault} alt="" />
        <b>
          <FormattedMessage
            id="chargingMap.otherStations"
            defaultMessage="Other stations"
            description="Other Types of Stations"
          />
        </b>
        <br />
        <span>
          <FormattedMessage
            id="chargingMap.privateStations"
            defaultMessage="Private Stations"
            description="Private Stations"
          />
        </span>
      </div>
      <div className="charger-type">
        <img className="multiple" src={ChargingPinDMultiple} alt="" />
        <b>
          <FormattedMessage
            id="chargingMap.multipleStations"
            defaultMessage="Multiple chargers available"
            description="Multiple Types of Stations"
          />
        </b>
      </div>
    </div>
  );
};

ChargingStationsMapLegend.propTypes = {
  chargingStations: PropTypes.array,
};

ChargingStationsMapLegend.defaultProps = {
  chargingStations: [],
};

export default ChargingStationsMapLegend;
